export const GET_RECOMMENDATION_ACTION = "GET_RECOMMENDATION_ACTION";
export const GET_RECOMMENDATION_SUCCESS = "GET_RECOMMENDATION_SUCCESS";

export const GET_RECOMMENDATION_FAIL = "GET_RECOMMENDATION_FAIL";